<template>
  <div></div>
</template>

<script>
import utils from "@/js/utils.js";
import { mapGetters } from "vuex";
import fb from "@/firebaseConfig";

export default {
  mounted() {
    const oauthparams = utils.parseOAuthQueryString(window.location.hash);
    const userCsrfToken = this.$cookies.get("dbx_csrf");

    if (userCsrfToken !== oauthparams.state) {
      alert("CSRF State Mismatch");
      return;
    }

    const unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type == "user/SET_LOGGED_IN" && mutation.payload == true) {
        fb.db
          .collection("users")
          .doc(this.user.details.uid)
          .update({ dbx_token: oauthparams.access_token })
          .then(() => {})
          .catch(err => {
            alert(err);
          });
        unsubscribe();
        this.$cookies.remove("dbx_csrf");
        this.$router.replace({ name: "profile" }).catch(err => {
          if (err) {
            console.log(err);
          }
        });
      }
    });
  },
  computed: {
    ...mapGetters({ user: "user/user" })
  }
};
</script>
